import { render, staticRenderFns } from "./Contrat.vue?vue&type=template&id=6a53a7a3&"
import script from "./Contrat.vue?vue&type=script&lang=ts&"
export * from "./Contrat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports